import { ReactElement, useCallback, useState } from 'react';
import { Button } from '@shared/components/Button';
import { View } from '@shared/components/View';
import { MBTextInput } from '@shared/components/textInput';
import { i18n } from '@shared/util/i18n';
import { MultiSelectProps } from './MultiSelect';

interface MBMultiSelectEditProps<T> extends MultiSelectProps<T> {
  value: T;
  isArchived?: boolean;
}
export function MBMultiSelectEdit<T>({
  value,
  isArchived,
  labelExtractor,
  onChangeLabel,
  onArchive,
  onUnarchive,
}: MBMultiSelectEditProps<T>): ReactElement {
  const [archived] = useState(isArchived);
  const [text, setText] = useState(labelExtractor?.(value) ?? '');
  const [archiving, setArchiving] = useState(false);
  const handleSave = useCallback(() => onChangeLabel?.(value, text), [onChangeLabel, text, value]);
  const handleUnarchive = useCallback(async () => {
    setArchiving(true);
    await onUnarchive?.(value);
  }, [onUnarchive, value]);
  const handleArchive = useCallback(async () => {
    setArchiving(true);
    await onArchive?.(value);
  }, [onArchive, value]);

  return (
    <View gap={2} paddingHorizontal={2} paddingVertical={2}>
      <MBTextInput autoFocus value={text} blurOnSubmit={true} onChangeText={setText} />
      <Button variant="primary" label={i18n('common.save')} onClick={handleSave} />
      <Button
        variant="ghost"
        danger={!archived}
        icon="archive-box"
        label={archived ? i18n('common.unarchive') : i18n('common.archive')}
        onClick={archived ? handleUnarchive : handleArchive}
        loading={archiving}
      />
    </View>
  );
}
